import { IconBase } from "./iconBase.js";
import { jsx } from "@emotion/react/jsx-runtime";
//#region src/tablet.tsx
var Tablet = ({ type, ...rest }) => /* @__PURE__ */ jsx(IconBase, {
	viewBox: "0 0 24 24",
	...rest,
	children: type === "stroke" ? /* @__PURE__ */ jsx("path", {
		d: "M18 1C19.6569 1 21 2.34315 21 4V20C21 21.6569 19.6569 23 18 23H6C4.34315 23 3 21.6569 3 20V4C3 2.34315 4.34315 1 6 1H18ZM6 2.5C5.17157 2.5 4.5 3.17157 4.5 4V20C4.5 20.8284 5.17157 21.5 6 21.5H18C18.8284 21.5 19.5 20.8284 19.5 20V4C19.5 3.17157 18.8284 2.5 18 2.5H6ZM15 17.75C15.4142 17.75 15.75 18.0858 15.75 18.5C15.75 18.9142 15.4142 19.25 15 19.25H9C8.58579 19.25 8.25 18.9142 8.25 18.5C8.25 18.0858 8.58579 17.75 9 17.75H15Z",
		fill: "currentColor"
	}) : /* @__PURE__ */ jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M6 1C4.34315 1 3 2.34315 3 4V20C3 21.6569 4.34315 23 6 23H18C19.6569 23 21 21.6569 21 20V4C21 2.34315 19.6569 1 18 1H6ZM9 18.25C8.58579 18.25 8.25 18.5858 8.25 19C8.25 19.4142 8.58579 19.75 9 19.75H15C15.4142 19.75 15.75 19.4142 15.75 19C15.75 18.5858 15.4142 18.25 15 18.25H9Z",
		fill: "currentColor"
	})
});
//#endregion
export { Tablet };
